/* eslint-disable @typescript-eslint/no-explicit-any -- These promise utils are generic and specific types are not known at compile time */ import { PromiseStatus } from './utils.enums';
export { PromiseStatus } from './utils.enums';
export function promiseWithTimeout(promise, limitMs) {
    return new Promise(function(resolve, reject) {
        var timeoutId = setTimeout(function() {
            return reject(new Error("Promise exceeded ".concat(limitMs, "ms timeout limit")));
        }, limitMs);
        promise.then(function(result) {
            clearTimeout(timeoutId);
            resolve(result);
        }, function(error) {
            clearTimeout(timeoutId);
            reject(error);
        });
    });
}
// Stage 3 Proposal
// https://github.com/tc39/proposal-promise-allSettled
function reflect(a) {
    return a.then(function(v) {
        return {
            status: PromiseStatus.Fulfilled,
            value: v
        };
    }, function(error) {
        return {
            status: PromiseStatus.Rejected,
            reason: error
        };
    });
}
export function allSettled(promises) {
    return Promise.all(promises.map(reflect));
}
export function timeDelay(milliseconds) {
    return new Promise(function(resolve) {
        return setTimeout(resolve, milliseconds);
    });
}

//# sourceMappingURL=promise-utils.js.map